export default __webpack_public_path__ + "static/media/location.e845ac54.svg";